module.exports = {
    MENU: 'Menu',
    QUANTRI_PHANHE : 'App',
    QUANTRI_NHOMQUYEN: 'RolesGroup',
    QUANTRI_QUYEN: 'Roles',
    QUANTRI_QUYENMENU: 'RolesMenu',
    QUANTRI_NGUOIDUNG: 'NguoiDung',
    QUANTRI_DONVI: 'DsDonVi',
    QUANTRI_LICHSUDANGNHAP: 'AppLoginHistory',
    QUANTRI_THONGKELICHSUDANGNHAP: 'ThongkeDangnhap',
    DANHMUC_TINHTP: 'DsTinhTp',
    DANHMUC_QUANHUYEN: 'DsQuanHuyen',
    DANHMUC_PHUONGXA: 'DsPhuongXa',
    DANHMUC_KHOMAP: 'DsKhomAp',
    DANHMUC_TODANPHO: 'DsToDanPho',
    DANHMUC_DUONGPHO: 'DsDuongPho',
    DANHMUC_CHUCDANH: 'DmChucDanh',
    DANHMUC_CAPDONVI: 'DmCapDonVi',
}
